<script lang="ts">
  import Button from "../../components/Button.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import Form from "../../components/Form/Form.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import GlobalErrors from "../../components/GlobalErrors.svelte";
  import OutsideLayout from "../../layout/OutsideLayout.svelte";
  import { doLogin, loginErrors } from "./login.store";

  export let username: string = "";
  export let password: string = "";

  function submit() {
    doLogin(username, password);
    username = "";
    password = "";
  }
</script>

<OutsideLayout title="Accesso Riservato">
  <Form>
    <GlobalErrors errors={$loginErrors} />

    <FormField>
      <Input bind:value={username} name="Login" />
    </FormField>

    <FormField>
      <Input bind:value={password} type="password" name="Password" />
    </FormField>

    <hr class="hr" />

    <div class="field is-grouped">
      <div class="control btn-centered">
        <Button klass="is-primary" on:click={submit}>Accedi</Button>
      </div>
    </div>
  </Form>
</OutsideLayout>

<style>
  .btn-centered {
    margin: 0 auto;
  }

  .hr {
    border: 0;
    border-top: 1px solid #eee;
    margin: 20px 0;
  }
</style>
